<template>
  <!--上传照片-->
  <div class="uploadbg">
    <div class="info-text">
      <img
        class="info-img"
        src="../../assets/images/activity/workshop/upload.png"
      />
    </div>
    <div class="info-content">
      <div class="input-row">
        <div class="info-name icon-user">
          <div class="image-upload">
            <van-uploader
              v-model="workshopfileList"
              :max-count="1"
              :after-read="workshopafterRead"
            >
              <img
                class="photosize"
                :src="workshopDefaultImg"
              />
              <div class="photofont">点击上传图片</div>
            </van-uploader>
          </div>
          <div class="image-alert">上传门头照</div>
        </div>
      </div>
      <div class="input-row">
        <div class="icon-user">
          <div class="image-upload">
            <van-uploader
              v-model="businessfileList"
              :max-count="1"
              :after-read="businessafterRead"
            >
              <img
                class="photosize"
                :src="businessDefaultImg"
              />
              <div class="photofont">点击上传图片</div>
            </van-uploader>
          </div>
          <div class="image-alert">上传营业执照</div>
        </div>
      </div>
      <div class="remarks">
        注：为了能顺利参与评选和抽奖，请上传真实有效清晰的照片。
      </div>
    </div>
    <div class="submit-btn">
      <van-button
        :loading="loading"
        type="info"
        size="normal"
        round
        @click="handleSubmit"
        ><img
          class="imgbtn"
          src="../../assets/images/activity/workshop/submit.png"
      /></van-button>
    </div>
  </div>
</template>

<script>
import activityApi from '@/api/activity'
import fileApi from '@/api/file'
import { commonUtils } from '@/utils/common'
export default {
  name: 'AcitvityWorkshopCollectPhoto',
  data () {
    return {
      loading: false,
      submitData: {
        workshopPhotoId: '',
        businessPhotoId: ''
      },
      workshopfileList: [],
      businessfileList: [],
      picInfo: {}
    }
  },
  computed: {
    workshopDefaultImg () {
      return this.picInfo.workshopPhotoUri ? commonUtils.getImageUrl(this.picInfo.workshopPhotoUri)
        : require('../../assets/images/activity/workshop/workshopPhoto.png')
    },
    businessDefaultImg () {
      return this.picInfo.businessPhotoUri ? commonUtils.getImageUrl(this.picInfo.businessPhotoUri)
        : require('../../assets/images/activity/workshop/businessPhoto.png')
    }
  },
  mounted () {
    this.queryCollectInfo()
  },
  methods: {
    showErroMsg (msg) {
      this.$toast({
        type: 'fail',
        duration: 1000,
        message: msg
      })
    },
    // 查询已有数据
    queryCollectInfo () {
      this.$toast.loading({
        message: '查询数据',
        forbidClick: true,
        loadingType: 'spinner',
        duration: 0
      })
      activityApi
        .workshopCollect()
        .then((response) => {
          this.$toast.clear()
          if (response.data.resultCode === '0') {
            this.picInfo = response.data.resultData.collectInfo.task2 || {}
          } else {
            this.showErroMsg(response.data.resultMsg)
          }
        })
        .catch(() => {
          this.$toast.clear()
        })
    },
    // 获取门头照ID
    workshopafterRead (file) {
      fileApi
        .uploadFilePublic(file.file)
        .then((response) => {
          if (response.data.resultCode === '0') {
            // this.submitData.workshopPhotoId =
            //   response.data.resultData.fileDTO.fileId
            file.fileDTO = response.data.resultData.fileDTO
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    // 获取营业执照ID
    businessafterRead (file) {
      fileApi
        .uploadFilePublic(file.file)
        .then((response) => {
          if (response.data.resultCode === '0') {
            // this.submitData.businessPhotoId =
            //   response.data.resultData.fileDTO.fileId
            file.fileDTO = response.data.resultData.fileDTO
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    // 重置参数
    resetInfo () {
      this.businessfileList = []
      this.submitData.businessPhotoId = ''
      this.submitData.workshopPhotoId = ''
      this.workshopfileList = []
    },
    // 提交按钮
    handleSubmit () {
      this.submitData.businessPhotoId = ''
      this.submitData.workshopPhotoId = ''
      if (this.workshopfileList && this.workshopfileList.length > 0 && this.workshopfileList[0].fileDTO) {
        this.submitData.workshopPhotoId = this.workshopfileList[0].fileDTO.fileId
      }
      if (this.businessfileList && this.businessfileList.length > 0 && this.businessfileList[0].fileDTO) {
        this.submitData.businessPhotoId = this.businessfileList[0].fileDTO.fileId
      }
      if (!this.submitData.workshopPhotoId && this.picInfo.workshopPhotoId) {
        this.submitData.workshopPhotoId = this.picInfo.workshopPhotoId
      }
      if (!this.submitData.businessPhotoId && this.picInfo.businessPhotoId) {
        this.submitData.businessPhotoId = this.picInfo.businessPhotoId
      }
      if (!this.submitData.workshopPhotoId) {
        this.showErroMsg('请上传门头照')
        return
      }
      if (!this.submitData.businessPhotoId) {
        this.showErroMsg('请上传营业执照')
        return
      }
      if (this.picInfo.task2VerifyStatus === 2 &&
        this.picInfo.workshopPhotoId === this.submitData.workshopPhotoId &&
        this.picInfo.businessPhotoId === this.submitData.businessPhotoId) {
        this.showErroMsg('请重新上传门头照或营业执照')
        return
      }
      this.$toast.loading({
        message: '照片提交中...',
        forbidClick: true,
        loadingType: 'spinner',
        duration: 0
      })
      activityApi
        .workshopCollectTask2Submit(this.submitData)
        .then((response) => {
          this.$toast.clear()
          if (response.data.resultCode === '0') {
            this.resetInfo()
            // 提交成功后跳转到活动主页面
            this.$router.back()
            // this.$router.push("/activity/activity-workshop-collect");
          } else {
            this.showErroMsg(response.data.resultMsg)
          }
        })
        .catch(() => {
          this.$toast.clear()
          this.showErroMsg('提交失败')
        })
    }
  }
}
</script>

<style lang="less" scoped>
.uploadbg {
  width: 100%;
  height: 100%;
  background-image: url("../../assets/images/activity/workshop/mainbg.png");
  background-size: 100% 100%;
  background-repeat: repeat-y;
  .info-text {
    padding: 50px 128px 20px 128px;
    .info-img {
      width: 118px;
      height: 29px;
    }
  }
  .info-content {
    width: 80%;
    margin: 0 auto;
    border-radius: 10px;
    background-color: rgb(250, 250, 250);
  }
  .input-row {
    position: relative;
    height: 180px;
    margin-bottom: 15px;
    .info-name {
      position: absolute;
      top: 15px;
    }
    .icon-user {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
    }
  }
}
.van-uploader {
  transform: translateY(50%);
}
.image-upload {
  width: 130px;
  height: 130px;
  background: rgb(240, 240, 240);
  margin-top: 5px;
  text-align: center;
  .photosize {
    width: 56px;
    height: 47px;
  }
  .photofont {
    color: rgb(33, 131, 147);
    font-size: 12px;
  }
  /deep/ .van-uploader__preview {
    margin: -10px 0 0 0;
    .van-image {
      display: flex;
      align-items: center;
      margin: 0 auto;
      .van-image__img {
        height: auto;
        width: auto;
        max-height: 100%;
        max-width: 100%;
        margin: 0 auto;
      }
    }
  }
}
.image-alert {
  font-size: 16px;
  text-align: center;
  margin-top: 13px;
  color: rgb(51, 51, 51);
}
.remarks {
  font-size: 10px;
  padding: 5px 50px 15px 50px;
  line-height: 20px;
  color: rgb(128, 128, 128);
}
.submit-btn {
  margin: 20px 5px;
  text-align: center;
  .van-button {
    width: 343px;
    height: 50px;
    line-height: 50px;
    background: rgb(227, 106, 91);
    border: none;
    border-radius: 8px;
    .imgbtn {
      width: 43px;
      height: 19px;
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      margin: auto auto;
    }
  }
}
</style>
